import React, { useState } from "react";
import Orderreq from "../../Datas/Orderreq";
import { QRCodeCanvas } from "qrcode.react";
import { jsPDF } from "jspdf";
import './OrderRequests.css';

const OrderRequests = () => {
  const [showModal, setShowModal] = useState(false);
  const [showQRCodeModal, setShowQRCodeModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);

  const handleShowModal = (order) => {
    setSelectedOrder(order);
    setShowModal(true);
    setShowQRCodeModal(false);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedOrder(null);
  };

  const handleShowQRCodeModal = () => {
    setShowQRCodeModal(true);
  };

  const generateQRCodeContent = () => {
    const orderDetails = selectedOrder.meds.map(med => (
      `Name: ${med.name}, Description: ${med.description}, Company: ${med.company}, Expiry: ${med.expiryDate}, Tags: ${med.tags.join(", ")}, Age Groups: ${med.ageGroups.join(", ")}, Quantity: ${med.quantity}`
    )).join(" | ");
    return orderDetails;
  };

  const downloadQRCodePDF = () => {
    const doc = new jsPDF();
    const qrCanvas = document.getElementById("qr-canvas");
    const imgData = qrCanvas.toDataURL("image/png");
    doc.addImage(imgData, "PNG", 10, 10, 180, 180);
    doc.save("order-qr-code.pdf");
  };

  return (
    <div className="order-requests-container-orderreq">
      <p className="heading-order-request">Customer Orders</p>
      <div className="customer-cards-container-orderreq">
        {Orderreq.map((order) => (
          <div key={order.customerId} className="customer-card-orderreq">
            <div className="customer-logo-orderreq">
              <img
                src={`https://img.freepik.com/free-vector/blue-circle-with-white-user_78370-4707.jpg?t=st=1733949514~exp=1733953114~hmac=1ec3f01117ca24fdfc3074ed5997d74f2d26bd091b39776a97e2c8f3dcf487f3&w=740`}
                alt={order.customerName}
              />
            </div>
            <div className="customer-info-orderreq">
              <h4>{order.customerName}</h4>
              <p>{order.location}</p>
            </div>
            <button
              onClick={() => handleShowModal(order)}
              className="view-order-button-orderreq"
            >
              View Order
            </button>
          </div>
        ))}
      </div>

      {selectedOrder && showModal && (
        <div className="modal-overlay-orderreq">
          <div className="modal-content-orderreq">
            <div className="modal-header-orderreq">
              <h4>Order Details for {selectedOrder.customerName}</h4>
              <button className="close-button-orderreq" onClick={handleCloseModal}>
                X
              </button>
            </div>
            <div className="modal-body-orderreq">
              <table className="meds-table-orderreq">
                <thead>
                  <tr>
                    <th>Medicine Name</th>
                    <th>Description</th>
                    <th>Company</th>
                    <th>Expiry Date</th>
                    <th>Tags</th>
                    <th>Age Groups</th>
                    <th>Quantity</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedOrder.meds.map((med, index) => (
                    <tr key={index}>
                      <td>{med.name}</td>
                      <td>{med.description}</td>
                      <td>{med.company}</td>
                      <td>{med.expiryDate}</td>
                      <td>{med.tags.join(", ")}</td>
                      <td>{med.ageGroups.join(", ")}</td>
                      <td>{med.quantity}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="modal-footer-orderreq">
              <button 
                className="confirm-button-orderreq"
                onClick={handleShowQRCodeModal}
              >
                Confirm Order
              </button>
              <button className="close-modal-button-orderreq" onClick={handleCloseModal}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {showQRCodeModal && (
        <div className="modal-overlay-orderreq">
          <div className="modal-content-orderreq">
            <div className="modal-header-orderreq">
              <h4>Scan QR Code for Order Details</h4>
              <button className="close-button-orderreq" onClick={() => setShowQRCodeModal(false)}>
                X
              </button>
            </div>
            <div className="modal-body-orderreq">
              <QRCodeCanvas
                id="qr-canvas"
                value={generateQRCodeContent()}
                size={256}
              />
            </div>
            <div className="modal-footer-orderreq">
              <button onClick={downloadQRCodePDF} className="download-qr-button">
                Download QR Code as PDF
              </button>
              <button className="close-modal-button-orderreq" onClick={() => setShowQRCodeModal(false)}>
                Close QR Code
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OrderRequests;
